// import React from 'react'

// const EditGenerateOrder = () => {
//   return (
//     <div>EditGenerateOrder</div>
//   )
// }

// export default EditGenerateOrder

import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import backicon from '../../../../Assets/icons/backIcon.svg';
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import axiosInstance from '../../../services/api/API';
// import "./CreateOrder.scss"
import CustomTable from '../../../customComponents/CustomTable';
import editIcon from '../../../../Assets/icons/Un-Checkbox.svg';
import deleteIcon from '../../../../Assets/icons/trash.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { buttonStyle, isFormValid } from '../../../../helpers/common';


const EditGenerateOrder = () => {
  const [validationErrors, setValidationErrors] = useState({});
  const [variantOptions, setVariantOptions] = useState([]);
  const [formData, setFormData] = useState({});
  const [itemCategoryOption, setItemcategoryOptions] = useState([]);
  const [accessoryOptions, setaccessoryOptions] = useState([]);
  const [draftId, setDraftId] = useState(0);

  const [isEdit, setIsEdit] = useState(false);
  const dealer_id = localStorage.getItem('dealerId');

  // Table data states

  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);

  // Modal for expected Date
  const [expectedDate, setExpectedDate] = useState('');
  const [formattedDate, setFormattedDate] = useState('');
  const [acceptModal, setAcceptModal] = useState(false);

  const [modelOptions, setModelOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);

  const datePickerRefs = useRef({}); // Reference for DatePicker

  const location = useLocation();
  const { data } = location.state || {};
  console.log(data, 'providedDAta');

  const handleChange = (fieldName, date) => {
    // Format the date to "dd/MM/yyyy" and update state
    const formattedDate = date
      ? date.toLocaleDateString('en-GB').replace(/\//g, '/')
      : '';
    setExpectedDate(formattedDate);
  };

  const openDatePicker = (fieldName) => {
    // Open DatePicker when icon is clicked
    if (datePickerRefs.current[fieldName]) {
      datePickerRefs.current[fieldName].setFocus();
    }
  };

  const handleAcceptModalOpen = () => {
    setAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setAcceptModal(false);
  };

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  const handleSubmit = async () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to create this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.patch(
            `/purchaseorder/update-purchase-order/${data.po_id}`,
            {
              po_expected_date: expectedDate,
              is_order_accepted: data.is_order_accepted === 8 ? 8 : 6,
              is_order_accepted: 0,
            },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          // if(response.status === 200){
          //           navigate("/manage-sales/manage-order")
          //         }

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Thanks for your confirmation.',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              navigate('/manage-sales/manage-order');
            });
          }
        } catch (error) {
          console.error('Error adding dealer:', error);
          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'This record was not added into draft.',
          icon: 'info',
          confirmButtonText: 'OK',
        });

        // setLoading(false);
      }
    });
  };

  // const handleSubmit = async () => {
  //     console.log("clicked")
  //     try{
  //       const response = await axiosInstance.patch(`/purchaseorder/update-purchase-order/${data.po_id}`,{
  //         po_expected_date: expectedDate,
  //         is_order_accepted: 0,
  //       }, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if(response.status === 200){
  //         navigate("/manage-sales/manage-order")
  //       }

  //     }catch(error){
  //       console.log(error, "error")
  //     }
  // }

  useEffect(() => {
    const colorId = formData.color;
    const modelId = formData.model;

    if (colorId && modelId) {
      fetchVariantOptions(colorId, modelId);
    }
  }, [formData.color, formData.model]);

  const fetchVariantOptions = async (colorId, modelId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {
          color_id: colorId,
          model_id: modelId,
          dealer_id: dealer_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    const variantId = formData.variant;

    if (variantId) {
      fetchVariantBasedDetails(variantId);
    }
  }, [formData.variant]);

  const fetchVariantBasedDetails = async (variantId, index) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariantbasedetails',
        { variant_id: variantId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const variantData = response?.data?.data?.data[0];
      console.log(variantData, 'variantData');

      if (formData.itemType === 'V') {
        setFormData((prevData) => ({
          ...prevData,
          color: variantData?.color_id,
          warranty: variantData?.warranty_name,
          basePrice: variantData?.exshowroom_price,
          tax: variantData?.tax_percent,
          remark: variantData?.remark,
        }));
      }
    } catch (error) {
      console.error('Error fetching variant-based details:', error);
    }
  };

  useEffect(() => {
    const itemTypeVal = formData.itemType;
    const variantId = formData.variant;

    if (itemTypeVal && variantId) {
      fetchItemCategoryOptions(itemTypeVal, variantId);
    }
  }, [formData.itemType, formData.variant]);

  const fetchItemCategoryOptions = async (itemTypeVal, variantId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/partcategory/ddlpartcategory',
        {
          itemtype: itemTypeVal,
          variant_id: variantId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setItemcategoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    const itemTypeVal = formData.itemType;
    const variantId = formData.variant;
    const categoryId = formData.category;
    const modelId = formData.model;

    if (
      itemTypeVal &&
      // && variantId
      // && categoryId
      modelId
    ) {
      fetchItemOptions(itemTypeVal, variantId, categoryId, modelId);
    }
  }, [formData.itemType, formData.variant, formData.category, formData.model]);

  const fetchItemOptions = async (
    itemTypeVal,
    variantId,
    categoryId,
    modelId,
  ) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitem',
        {
          itemtype: itemTypeVal,
          variant_id: variantId || 0,
          category_id: categoryId || 0,
          model_id: modelId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setaccessoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    const accessoryId = formData.accessory;

    if (accessoryId) {
      fetchItemBasedDetails(accessoryId);
    }
  }, [formData.accessory]);

  const fetchItemBasedDetails = async (accessoryId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitembase',
        { item_id: accessoryId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const itemData = response?.data?.data?.data[0];
      console.log(itemData, 'itemData');

      setFormData((prevData) => ({
        ...prevData,
        color: itemData?.colour_id,
        warranty: itemData?.warranty_name,
        basePrice: itemData?.purchase_price,
        tax: itemData?.tax_percent,
      }));
    } catch (error) {
      console.error('Error fetching variant-based details:', error);
    }
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      itemType: 'V',
    }));
  }, []);

  // useEffect(() => {
  //   if (formData.itemType) {
  //     setFormData({
  //       itemType: formData.itemType, // Retain only the itemType
  //     });
  //   }
  // }, [formData.itemType]);

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        orderBy: 'model_id desc',
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post('/model/ddlmodel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  useEffect(() => {
    const modelId = formData.model;

    if (!modelId) {
      setColorOptions([]);
      setFormData((prev) => ({
        ...prev,
        color: null,
      }));
    } else {
      fetchColorOptions(modelId);
    }
  }, [formData.model]);

  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      const response = await axiosInstance.post('/color/ddlcolor', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  // Form Inputs
  const POInputs = [
    {
      name: 'itemType',
      label: 'Item Type',
      placeholder: 'Enter ',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        { value: 'S', label: 'Spare Part' },
      ],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    {
      // name: "variant",
      name: 'model',
      label: 'Model',
      placeholder: '',
      type: 'dropdown',
      options: modelOptions,
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    {
      name: 'color',
      label: 'Color',
      placeholder: 'Color',
      type: 'dropdown',
      options: colorOptions,
      required: true,
      // disabled:true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },

    ...(formData.itemType === 'V'
      ? [
          {
            // name: "variant",
            name: 'variant',
            label: 'Variant',
            placeholder: '',
            type: 'dropdown',
            options: variantOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),

    // ...( formData.itemType !== "V"
    //   ?
    //   [
    //   {
    //       name: "category",
    //       label: "Category",
    //       placeholder:"",
    //       type: "dropdown",
    //       options:itemCategoryOption,
    //       required: true,
    //       gridClass: "col-lg-3",
    //       validation: { required: true },

    //     },
    // ]: []
    // ),
    ...(formData.itemType !== 'V'
      ? [
          {
            name: 'accessory',
            label: 'Item Name',
            placeholder: '',
            type: 'dropdown',
            options: accessoryOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),

    // {
    //     name: "warranty",
    //     label: "Warranty",
    //     placeholder: "Warranty",
    //     type: "text",
    //     disabled:true,
    //     gridClass: "col-lg-3",
    //   },
    {
      name: 'quantity',
      required: true,
      label: 'Request Quantity',
      placeholder: 'Enter Quantity',
      type: 'text',
      gridClass: 'col-lg-3',
      validation: {
        required: true,
        pattern: /^[1-9][0-9]*$/,
        message: 'Please enter a positive number with no leading zeros',
      },
    },
    {
      name: 'basePrice',
      label: 'Base Price',
      placeholder: 'Base Price',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
    },
    {
      name: 'tax',
      label: 'GST',
      placeholder: 'Enter GST',
      type: 'text',
      // disabled:true,
      gridClass: 'col-lg-3',
      required: 'true',
    },
    {
      name: 'taxamount',
      label: 'GST Amount',
      placeholder: 'Enter GST Amount',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
    {
      name: 'basePricewithGst',
      label: 'Base Price With GST',
      placeholder: 'Enter Base Price with GST Amount',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
    {
      name: 'totalAmount',
      label: 'Total Amount',
      placeholder: 'Enter Total Amount',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
    {
      name: 'job_card_number',
      label: 'Job Card No',
      placeholder: 'Job Card No',
      type: 'text',
      // disabled:true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
    {
      name: 'remark',
      label: 'Remark',
      placeholder: 'Enter Remark',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
  ];

  // Table Data
  const TABLE_HEADERS = [
    'PO Draft No.',
    'Variant Name',
    'Item Name',
    'ProductImage',
    'Color',
    'Item Type',
    // "Category Name",
    'Variant Name',
    'Quantity',
    'Approved Quanity',
    'Rate',
    'Tax',
    'Tax Amount',
    'Total Amount',
    'Job Card Number',
    // "Remark",
    'Action',
  ];

  useEffect(() => {
    console.log(data.po_number, 'dataPoDetails');
  }, []);

  const keyMapping = {
    'PO Draft No.': 'podetail_number',
    'Variant Name': 'NAME',
    'Item Name': 'item_name',
    ProductImage: 'productimage',
    Color: 'color_name',
    'Item Type': 'itemtype_name',
    'Category Name': 'part_category_name',
    'Variant Remark': 'variant_remark',
    'Job Card Number': 'job_card_number',
    Quantity: 'quantity',
    'Approved Quanity': 'accepted_qty',
    Rate: 'baseprice',
    Tax: 'tax_percent',
    'Tax Amount': 'taxamount',
    // "Remark":"",
    'Total Amount': 'totalamount',
    Action: [
      { type: 'edit', icon: editIcon, label: 'Edit' },
      { type: 'delete', icon: deleteIcon, label: 'Delete' },
    ],
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleEdit = (rowData) => {
    setIsEdit(true);
    console.log(rowData.po_draft_id, 'clicked');
    setDraftId(rowData.po_details_id);
    getDetailsEdit(rowData.po_details_id);
    // navigate(`${ROUTES_NAVIGATION.EDITPRODUCT}`, { state: { data: rowData } });
  };

  // const handleFormSave = async (formData) => {
  //   console.log(formData, "clicked")

  //   try{

  //     const payload =
  // formData.itemType === "V"
  //   ? {
  //       variant_id: formData.variant, // Pass variant_id for Vehicle
  //     }
  //   : formData.itemType === "A" || formData.itemType === "S"
  //   ? {
  //       item_id: formData.accessory, // Pass item_id for Accessory or Spare Part
  //     }
  //   : {};

  //   payload.quantity = formData.quantity;
  //   payload.itemtype = formData.itemType;

  //   payload.po_number = data.popo_number,
  //   payload.po_id = data.po_id

  //   const url = isEdit
  // ? `/purchaseorder/update-draft/${draftId}`
  // : "purchaseorder/create-draft";

  //         const method = isEdit ? "patch" : "patch";

  //         const response = await axiosInstance({
  //         method, // Dynamically set the HTTP method
  //         url,
  //         data: payload,
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //     if(response.status === 200){
  //       setFormData({})
  //       fetchTableList()
  //       setIsEdit(false);
  //     }

  //   }catch(error){
  //     console.log(error, "error")
  //   }
  // }

  const handleFormSave = async (formData) => {
    // const errors = {};
    // let isValid = true;

    // POInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     }
    //   } else if (
    //     field.required &&
    //     field.validation &&
    //     field.validation.pattern &&
    //     !field.validation.pattern.test(formData[field.name])
    //   ) {
    //     errors[field.name] = field.validation.message;
    //     isValid = false;
    //   }
    // });

    // if (!isValid) {
    //   setValidationErrors(errors);
    //   return;
    // }

    if (!isFormValid(POInputs, formData, validationErrors)) {
      const errors = {};
      POInputs.forEach((field) => {
        const value = formData[field.name];
        if (field.validation?.required && !value) {
          errors[field.name] = 'This field is required';
        }
        if (value && field.validation?.pattern && !field.validation.pattern.test(value)) {
          errors[field.name] = field.validation.message;
        }
      });
      setValidationErrors(errors);
      return;
    }

    try {
      // Build the base payload based on itemType
      const payload =
        formData.itemType === 'V'
          ? {
              variant_id: formData.variant, // Pass variant_id for Vehicle
              color_id: formData.color,
              model_id: formData.model,
            }
          : formData.itemType === 'A' || formData.itemType === 'S'
            ? {
                item_id: formData.accessory, // Pass item_id for Accessory or Spare Part
                model_id: formData.model,
              }
            : {};

      // Common payload properties
      payload.quantity = formData.quantity;
      payload.itemtype = formData.itemType;
      payload.job_card_number = formData.job_card_number;
      payload.is_order_accepted = data.is_order_accepted === 8 ? 8 : 6;

      // Conditionally add po_number and po_id for create-draft
      if (!isEdit) {
        payload.po_number = data.po_number;
        payload.po_id = data.po_id;
      }

      // Determine API URL and method
      const url = isEdit
        ? `/purchaseorder/update-draft/${draftId}`
        : 'purchaseorder/create-draft';
      const method = isEdit ? 'patch' : 'post';

      // Make the API call
      const response = await axiosInstance({
        method, // Dynamically set the HTTP method
        url,
        data: payload,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      // Handle success response
      if (response.status === 200) {
        setFormData({});
        fetchTableList();
        setIsEdit(false);
      }
    } catch (error) {
      console.log(error, 'error');
    }
  };

  useEffect(() => {
    fetchTableList();
  }, []);

  // fetching table data
  // const fetchTableList = async (page = 0, pageSize = 10) => {
  //   try {
  //     // setLoading(true)
  //     const response = await axiosInstance.post(`/purchaseorder/list-po-draft/${data.po_id}`,{
  //       is_order_accepted: 8,
  //       po_id: data.po_id
  //     },{
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       }
  //     });

  //     const formattedData = response?.data?.data?.map((item, index) => ({
  //       ...item,
  //       "Sr No.": index + 1 + page * pageSize,
  //       variant_name:item.variant_name || "--",
  //       // productimage: item.productimage || "--",
  //       part_category_name:item.part_category_name || "--"
  //     }));

  //     setProductData(formattedData);
  //     setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

  //   } catch (error) {
  //     console.error('Error fetching product list:', error);
  //   }
  //   finally{
  //     // setLoading(false)
  //   }
  // };

  const fetchTableList = async (page = 0, pageSize = 10) => {
    try {
      // setLoading(true)

      const payload = {
        is_order_accepted: data.is_order_accepted === 8 ? 8 : 6, // Dynamically set the value
        po_id: data.po_id,
      };

      const response = await axiosInstance.post(
        `/purchaseorder/list-po-draft`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1 + page * pageSize,
        variant_name: item.variant_name || '--',
        part_category_name: item.part_category_name || '--',
        item_name: item.item_name || '--',
      }));

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching product list:', error);
      const errorMessage = error.response?.data?.data;
      console.log(errorMessage, 'errorMessage');
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      // setLoading(false)
    }
  };

  const getDetailsEdit = async (poDetailsId) => {
    console.log(poDetailsId, 'poDraftId');
    try {
      // setLoading(true)
      const response = await axiosInstance.get(
        `/purchaseorder/edit-draft/${poDetailsId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data[0];
      console.log(fetchedData, 'getEditData');

      setFormData((prevData) => ({
        ...prevData,
        itemType: fetchedData?.itemtype,
        variant: fetchedData?.variant_id,
        // color:fetchedData?.color_name,
        warranty: fetchedData?.warranty_name,
        basePrice: fetchedData?.baseprice,
        quantity: fetchedData?.quantity,
        tax: fetchedData?.tax_percent,
        totalAmount: fetchedData?.totalprice,
        taxamount: fetchedData?.taxset_amount,
        accessory: fetchedData?.item_id,
        category: fetchedData?.category_id,
        color: fetchedData?.color_id,
        model: fetchedData?.model_id,
        basePrice: fetchedData?.rate,
        // basePrice:fetchedData?.baseprice,
        job_card_number: fetchedData?.job_card_number,
      }));
    } catch (error) {
      console.error('Error fetching product list:', error);
    } finally {
      // setLoading(false)
    }
  };

  const handleDelete = async (rowData) => {
    console.log('clicked', rowData);
    try {
      const response = await axiosInstance.get(
        `/podraftdetails/removeProductsorder/${rowData.po_details_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        console.log('Item deleted successfully');
        fetchTableList();
      } else {
        console.error('Failed to delete item');
      }
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  };

  // const handleDateChange = (e) => {
  //   const value = e.target.value;
  //   const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

  //   // Check if input matches the dd/mm/yyyy format
  //   if (value === '' || dateRegex.test(value)) {
  //     setExpectedDate(value);
  //   }
  // };

  const handleModifySubmit = async () => {
    console.log('clicked');
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to modify?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.patch(
            `/purchaseorder/update-purchase-order/${data.po_id}`,
            {
              po_expected_date: expectedDate || null,
              is_order_accepted: 8,
              // is_order_accepted: 0,
            },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            navigate('/manage-sales/manage-order');
            Swal.fire({
              title: 'Success',
              text: 'Purchase order modified successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          }

          if (response.status === 200) {
            navigate('/manage-sales/manage-order');
          }
        } catch (error) {
          console.error('Error adding dealer:', error);
          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'This record was not modified.',
          icon: 'info',
          confirmButtonText: 'OK',
        });

        // setLoading(false);
      }
    });
  };

  const handleDraftSubmit = async () => {
    console.log('clicked');
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to save this draft?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.post(
            '/purchaseorder/create',
            {
              is_order_accepted: 6,
              po_expected_date: null,
            },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            navigate('/manage-sales/manage-order');
          }
        } catch (error) {
          console.error('Error adding dealer:', error);
          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'This record was not added into draft.',
          icon: 'info',
          confirmButtonText: 'OK',
        });

        // setLoading(false);
      }
    });
  };

  //   const handleDraftSubmit = async () => {
  //     console.log("clicked")
  //     try{
  //       const response = await axiosInstance.post('/purchaseorder/create',{
  //         is_order_accepted: 6,
  //         po_expected_date:null
  //       }, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if(response.status === 200){
  //         navigate("/manage-sales/manage-order")
  //       }

  //     }catch(error){
  //       console.log(error, "error")
  //     }
  // }

  useEffect(() => {
    if (formData?.itemType) {
      setFormData({ itemType: formData?.itemType });
    }
  }, [formData?.itemType]);

  useEffect(() => {
    console.log('Model Effect Triggered, current model:', formData?.model);
    // Always clear child options and values when model changes
    setColorOptions([]);
    setFormData((prev) => ({
      ...prev,
      color: null,
      variant: null,
    }));
  }, [formData?.model]);

  useEffect(() => {
    console.log('Color Effect Triggered, current color:', formData?.color);
    // Always clear variant options and values when color changes
    setVariantOptions([]);
    setFormData((prev) => ({
      ...prev,
      variant: null,
    }));
  }, [formData?.color]);

  useEffect(() => {
    if (!formData?.variant && !formData.accessory) {
      setFormData((prev) => ({
        ...prev,
        quantity: null,
        basePrice: null,
        tax: null,
        totalAmount: null,
        taxamount: null,
        basePricewithGst: null,
      }));
    }
  }, [formData?.variant]);

  useEffect(() => {
    if (!formData?.quantity || formData?.quantity === '0') {
      setFormData((prev) => ({
        ...prev,
        totalAmount: null,
      }));
    }
  }, [formData?.quantity]);

  return (
    <div>
      <div
        style={{ paddingTop: '20px', borderBottom: '1px solid lightgray' }}
        className="header-container"
      >
        <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
          <img src={backicon} alt="back" />
          <span className="backbtntitle">Edit Purchase Order</span>
        </div>

        {data.is_order_accepted === 8 ? (
          <div style={{ paddingRight: '18px' }}>
            <button
              style={{ padding: '1rem' }}
              className="submit-btn"
              onClick={handleModifySubmit}
            >
              Modify
            </button>
          </div>
        ) : (
          <>
            <div style={{ paddingRight: '12px' }}>
              {/* <button className="submit-btn" onClick={handleDraftSubmit}>
                Save to Draft
              </button> */}
            </div>
            <div>
              <button className="submit-btn" onClick={handleAcceptModalOpen}>
                Generate Order
              </button>
            </div>
          </>
        )}

        {/* <div>
            <button className="submit-btn" onClick={handleAcceptModalOpen}>
              Generate Order
            </button>
          </div> */}
      </div>

      {acceptModal && (
        <div className="customModalOverlay">
          <div className="custom-modal-expectedDate">
            <div className="custom-modal-header">
              <h6 style={{ fontSize: '18px' }}>Expected Delivery Date</h6>
              <button className="close-button" onClick={closeAcceptModal}>
                ×
              </button>
            </div>
            <div className="custom-modal-body">
              <label
                htmlFor="expectedDate"
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                }}
              >
                Expected Delivery Date
              </label>
              {/* <input
                          type="date"
                          id="expectedDate"
                          value={expectedDate} // Replace `remark` with a new `expectedDate` state
                          onChange={(e) => setExpectedDate(e.target.value)} // Ensure to create `setExpectedDate` for state management
                          style={{padding:"14px", borderRadius:"18px", border:"1px solid gray"}}
                        /> */}
              <div className="input-group">
                <DatePicker
                  ref={(ref) => (datePickerRefs.current['expectedDate'] = ref)}
                  placeholderText="DD/MM/YYYY"
                  selected={
                    expectedDate
                      ? new Date(expectedDate.split('/').reverse().join('-'))
                      : null
                  }
                  onChange={(date) => handleChange('expectedDate', date)}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  popperPlacement="bottom-start"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  minDate={new Date()}
                />
                <span
                  className="input-group-text"
                  onClick={() => openDatePicker('expectedDate')}
                  style={{ cursor: 'pointer' }}
                >
                  <FaCalendarAlt />
                </span>
              </div>
            </div>
            <div className="custom-modal-footer">
              <button
                className="btn btn-primary"
                style={{
                  background: '#7BD755',
                  color: 'white',
                  border: 'none',
                  borderRadius: '20px',
                  padding: ' 10px 28px',
                }}
                onClick={handleSubmit}
              >
                Submit
              </button>
              <button
                className="btn btn-primary"
                style={{
                  background: 'white',
                  color: '#7BD755',
                  border: '1px solid #7BD755',
                  borderRadius: '20px',
                  padding: ' 10px 28px',
                }}
                onClick={closeAcceptModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Form */}

      <div
        className="PO-form-container"
        style={{ paddingLeft: '47px', marginTop: '50px', paddingTop: '15px' }}
      >
        <p
          style={{ color: '#000', paddingBottom: '12px', paddingTop: '12px' }}
          className="section-title"
        >
          Add Vehicle / Spare Part
        </p>
        <div>
          <DynamicForm
            formConfig={POInputs}
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: '15px',
            paddingTop: '20px',
            alignItems: 'center',
          }}
        >
          <button
            // onClick={() => { handleClaimSubmit(formData)}}
            className="clear-btn"
            style={{ paddingLeft: '35px', paddingRight: '35px' }}
            onClick={() => setFormData({})}
          >
            Reset
          </button>
          <button
            className="submitt-btn"
            disabled={!isFormValid(POInputs, formData, validationErrors)}
            style={buttonStyle(POInputs, formData, validationErrors)}
            onClick={() => {
              handleFormSave(formData);
            }}
          >
            Save
          </button>
        </div>
      </div>

      {/* Custom Table */}

      <div>
        <CustomTable
          data={productData}
          headers={TABLE_HEADERS}
          keyMapping={keyMapping}
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit}
          totalRecords={totalRecords}
          handleDelete={handleDelete}
          isADDcomplainTable="true"
        />
      </div>
    </div>
  );
};

export default EditGenerateOrder;
